// import 'bootstrap';

import {createApp} from "vue";
import CityFilterHero from "./components/CityFilterHero.vue";

const app = createApp({});
app.component('CityFilterHero', CityFilterHero);
app.mount('#city-filter-hero');
